import React, { useState } from 'react';
import { userService, conversationsService } from '../services';

export default function AddMemberModal({ conversationId, onClose, onAdded }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearch = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await userService.searchUsers(query, 1, 5);
      // normalize to array
      const arr = Array.isArray(res) ? res : (res?.items || []);
      setResults(arr);
    } catch (err) {
      setError(err?.message || 'Search failed');
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = async (user) => {
    try {
      const payload = { userId: user.id || user.userId || user._id };
      await conversationsService.addMember(conversationId, payload);
      if (onAdded) onAdded(user);
      onClose();
    } catch (err) {
      setError(err?.response?.data || err?.message || 'Failed to add member');
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-panel">
        <h3>Add people</h3>
        <div>
          <input value={query} onChange={e => setQuery(e.target.value)} placeholder="Search username or email" />
          <button onClick={handleSearch} disabled={loading}>Search</button>
          <button onClick={onClose}>Cancel</button>
        </div>
        {error && <div className="error">{String(error)}</div>}
        <div className="search-results">
          {loading && <div>Searching...</div>}
          {!loading && results && results.length === 0 && <div>No results</div>}
          {results.map(u => (
            <div key={u.id || u.userId || u._id} className="search-item">
              <div className="search-item-info">
                <div className="search-name">{u.displayName || u.fullName || u.username || u.userName || u.email}</div>
                <div className="search-sub">{u.email || u.username}</div>
              </div>
              <div>
                <button onClick={() => handleAdd(u)}>Add</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
